<div class="bg-login d-flex justify-content-center align-items-center">
  <div class="d-flex">
    <div class="recoveryMainSection p-4">
      <h3 class="title3 text-white text-center mb-3">{{ 'ACTIVATE.TITLE' | translate }}</h3>

      @if (success) {
        <p class="success paragraphText text-center">
          {{ success }}
        </p>
      }
    </div>

    @if (!isLittleScreen) {
      <div class="recoveryExtraSection p-4 d-flex flex-column">
        <h6>{{ 'ACTIVATE.EXTRA_TITLE' | translate }}</h6>
        <p class="darkText">{{ 'ACTIVATE.EXTRA_SUBTITLE' | translate }}</p>
      </div>
    }
  </div>
</div>
